const Spacer = ({ height="20px" }) => {
    return (
        <div style={{height: height}}></div>
    )
}

export default Spacer